module.exports = __webpack_public_path__ + "static/media/abbott.cb1a17a5.jpeg";